import { Cast } from '@/modules/casts/classes'
import store from '@/store'
import { KeyDict } from '@/types'
import { AssetType } from '@/types/assets'
import { SceneContentCast } from '@/types/sceneContent'
import { computed, onUnmounted, Ref, watch } from '@vue/composition-api'

const useCastsInCast = (cast: Ref<Cast|null>) => {

  const sceneCastIds = computed(() => {
    if (!cast.value) return []
    const castsInScenes = cast.value.getScenesContents([AssetType.Cast], false) as KeyDict<SceneContentCast>
    return Object.values(castsInScenes).map((content) => content.castId)
  })

  const hasChinaCast = computed((() => {
    const filteredCasts = Object.values(store.state.casts.subscribedCasts).filter(
    (aCast) => aCast.regionalInfo?.fixed ?? false)
    return filteredCasts.length > 0
  }))

  const sceneCasts = computed(() => Object.values(store.state.casts.subscribedCasts).filter(
    (aCast) => sceneCastIds.value.includes(aCast.id)))

  watch(sceneCastIds, async (newCastIds, oldCastIds) => {
    const promises = []
    if (oldCastIds !== undefined) {
      for (const roomId of oldCastIds) {
        if (!newCastIds.includes(roomId)) promises.push(store.dispatch.casts.unsubscribeCast(roomId))
      }
    }
    for (const roomId of newCastIds) {
      if (oldCastIds === undefined || !oldCastIds.includes(roomId)) {
        promises.push(store.dispatch.casts.subscribeCast(roomId))
      }
    }
    const results = await Promise.allSettled(promises)
    results.forEach((result) => {
      if (result.status === 'fulfilled' && result.value) {
        result.value.logIfError('Error while subscribing to cast scenes')
      }
      if (result.status === 'rejected') console.error('Error subscribing/unsubscribing to cast scenes', result.reason)
    })
  }, { immediate: true })

  onUnmounted(async () => {
    const promises = []
    for (const roomId of sceneCastIds.value) promises.push(store.dispatch.casts.unsubscribeCast(roomId))
    const results = await Promise.allSettled(promises)
    results.forEach((result) => {
      if (result.status === 'rejected') console.error('Error unsubscribing to cast scenes', result.reason)
    })
  })

  return {
    hasChinaCast,
    sceneCastIds,
    sceneCasts
  }
}

export default useCastsInCast
